import { AuthTokens } from "../types";
import { STORAGE_KEYS } from "../../constants";
import { getFromStorage, removeFromStorage, saveToStorage } from "./storageUtils";

export const saveTokens = async (tokens: AuthTokens): Promise<void> => {
  await saveToStorage(STORAGE_KEYS.AUTH_TOKENS, tokens);
};

export const getTokens = (): AuthTokens | null => {
  return getFromStorage<AuthTokens>(STORAGE_KEYS.AUTH_TOKENS);
};

export const clearTokens = async (): Promise<void> => {
  await removeFromStorage(STORAGE_KEYS.AUTH_TOKENS);
};
